
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/innskraning",
      function () {
        return require("private-next-pages/innskraning/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/innskraning"])
      });
    }
  